const ColorPalette = ({colorPalette}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="94" height="92" viewBox="0 0 94 92">
            <defs>
                <clipPath id="clip-path">
                    <path id="Rectangle_1851" data-name="Rectangle 1851" d="M23,0H71A23,23,0,0,1,94,23V69A23,23,0,0,1,71,92H23A23,23,0,0,1,0,69V23A23,23,0,0,1,23,0Z" fill="none"/>
                </clipPath>
            </defs>
            <g id="Group_555" data-name="Group 555" transform="translate(-0.3 -4.259)">
                <g id="Group_554" data-name="Group 554" transform="translate(0.3 4.259)">
                    <rect id="Rectangle_1843" data-name="Rectangle 1843" width="19.18" height="102.182" transform="translate(37.232 -4.259)" fill={colorPalette.primary.main} />
                    <rect id="Rectangle_1844" data-name="Rectangle 1844" width="7.673" height="102.182" transform="translate(71.404 -4.259)" fill={colorPalette.secondary.main}/>
                    <rect id="Rectangle_1845" data-name="Rectangle 1845" width="7.673" height="102.182" transform="translate(79.077 -4.259)" fill={colorPalette.quaternary.accent}/>
                    <rect id="Rectangle_1846" data-name="Rectangle 1846" width="7.682" height="102" transform="translate(86.561 -4.235)" fill={colorPalette.quaternary.main}/>
                    <rect id="Rectangle_1847" data-name="Rectangle 1847" width="7.682" height="102" transform="translate(56.426 -4.235)" fill={colorPalette.tertiary.main}/>
                    <rect id="Rectangle_1848" data-name="Rectangle 1848" width="7.673" height="102.182" transform="translate(63.732 -4.259)" fill={colorPalette.tertiary.accent}/>
                    <rect id="Rectangle_1849" data-name="Rectangle 1849" width="18.908" height="102" transform="translate(18.608 -4.235)" fill={colorPalette.primary.accent}/>
                    <rect id="Rectangle_1850" data-name="Rectangle 1850" width="18.908" height="102" transform="translate(-0.3 -4.235)" fill={colorPalette.secondary.accent}/>
                </g>
            </g>
        </svg>
    )
}

export default ColorPalette
